import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import notify from "../utils/notify";
import AuthShell from '../components/public/AuthShell';

const EmailConfirmationPendingPage = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.isEmailConfirmed) {
      notify.success('Email already confirmed! Redirecting to login...');
      navigate('/login');
    }
  }, [authData, navigate]);

  return (
    <AuthShell title="Confirm your email" subtitle="You need to confirm your email address before you can use the platform.">
      <p className="auth-text">We sent a confirmation link to your inbox. Open it, then sign in. Check your spam folder if you can't find it.</p>
      <div className="auth-stack">
        <Link to="/resend-confirmation" className="auth-btn auth-btn--block">
          Resend the email
        </Link>
        <Link to="/login" className="auth-btn auth-btn--ghost auth-btn--block">
          Back to sign in
        </Link>
      </div>
    </AuthShell>
  );
};

export default EmailConfirmationPendingPage;
